<template>
    <div class="container mt-5">
        <div v-if="this.status === 'success'" class="card">
            <div class="card-header">
                <h3>{{ $t('email.heading.email_verification') }}</h3>
            </div>
            <div v-if="this.verified" class="card-body">
                <h3 class="note-color-btn">{{ this.first_name + ' ' + $t('email.heading.dear') }}</h3>
                <p>
                    {{ $t('email.text.email_verified') }}
                </p>
            </div>
            <div v-else class="card-body">
                <p>
                    {{ $t('email.text.email_not_verified') }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
// import {mapGetters} from "vuex";
import { verifyMailService } from '@/common/api.service'


export default {
    computed: {
        // ...mapGetters('verifyMail', [
        //     'verification', 'status'
        // ]),
    },
    data() {
        return {
            tracking_code: this.$route.params.tracking_code,
            status: 'loading',
            verified: false,
            first_name: '',
        }
    },
    mounted() {
        this.$nextTick(function () {
            this.verify()
        })
    },
    methods: {
        verify() {
            verifyMailService.verify(this.tracking_code)
                .then((response) => {
                    this.status = 'success'
                    this.verified = response.data.data.verified
                    this.first_name = response.data.data.first_name
                })
                .catch((error) => {
                    this.showMsg(form, 'danger', error.response.data.message)
                })
        },
    },
}
</script>